export function memoSelector(selectors, transformer) {
    // TODO: store only last value, not entire history
    const store = {};

    return (state) => {
        const values = selectors.map((f) => f(state));

        if (store.hasOwnProperty(values)) {
            return store[values];
        }

        const x = transformer(...values);
        store[values] = x;
        return x;
    };
}
